import Swiper from 'swiper';

export function reviewsSlider() {

    let sliderReviews = new Swiper('.reviews-slider', {
        containerModifierClass: 'reviews-slider',
        wrapperClass: 'reviews-slider__wrapper',
        slideClass: 'reviews-slide',
        slideActiveClass: 'is-active',
        simulateTouch: false,
        slidesPerView: 1,
        width: 290,
        breakpoints: {
            780: {
                width: 750,
            }
        }
    });

    let prev = document.querySelectorAll('[am-prev="reviews"]'),
        next = document.querySelectorAll('[am-next="reviews"]');

    next.forEach( function(item) {

        sliderReviews.on('slideChange', function() {
            if (sliderReviews.isBeginning) {
                item.classList.add('is-active')
            } else if (sliderReviews.isEnd) {
                item.classList.remove('is-active')
            } else {
                item.classList.add('is-active')
            }
        })

        item.addEventListener('click', function() {
            sliderReviews.slideNext()
        });
    });

    prev.forEach( function(item) {

        sliderReviews.on('slideChange', function() {
            if (sliderReviews.isBeginning) {
                item.classList.remove('is-active')
            } else if (sliderReviews.isEnd) {
                item.classList.add('is-active')
            } else {
                item.classList.add('is-active')
            }
        })

        item.addEventListener('click', function() {
            sliderReviews.slidePrev()
        });
    });
}
